export const CHANNEL_ID = {
  WEB_TO_TEXT: 'web-to-text',
  BOOK_ONLINE: 'book-online',
  REPUTATION: 'reputation',
  CALL_US: 'call-us',
  CUSTOM_CTA: 'custom-cta'
}

export const CHANNEL_TYPES = {
  WIDGET: 'widget',
  PHONE: 'phone',
  LINK: 'link'
}

export const MULTI_CHANNEL_WIDGETS = [
  {
    id: CHANNEL_ID.WEB_TO_TEXT,
    widgetId: '9257718d-b973-49c2-a05a-64baacb5d34a',
    renderType: 'floating-element',
    icon: 'chat',
    label: 'Text us',
    type: CHANNEL_TYPES.WIDGET
  },
  {
    id: CHANNEL_ID.BOOK_ONLINE,
    widgetId: 'c94c6f5b-e23a-44fa-94f6-759bf4ad676d',
    renderType: 'modal',
    icon: 'calendar',
    label: 'Make an appointment',
    type: CHANNEL_TYPES.WIDGET
  },
  {
    id: CHANNEL_ID.REPUTATION,
    widgetId: 'a9a6fab9-c916-4829-8bf9-0682c5d76416',
    renderType: 'modal',
    icon: 'star--circle',
    label: 'Leave a review',
    type: CHANNEL_TYPES.WIDGET
  },
  {
    id: CHANNEL_ID.CALL_US,
    icon: 'phone',
    label: 'Call us',
    type: CHANNEL_TYPES.PHONE
  },
  {
    id: CHANNEL_ID.CUSTOM_CTA,
    icon: 'link',
    label: 'link',
    type: CHANNEL_TYPES.LINK
  }
]

export const MULTICHANNEL_DEFAULT_SETTINGS = {
  headingText: 'How can we help?',
  subHeadingText: 'Choose from the following options',
  backgroundColor: '#656E8B',
  textColor: '#FFFFFF',
  customLinkUrl: '',
  customLinkLabel: ''
}

export const WIDGET_ID = '78f5d704-8243-4c93-91c9-9de9517505fc'
export const WIDGET_SLUG = 'multi-channel'
export const LOCAL_STORAGE_PARAMS_KEY = `pp-widget-params-${WIDGET_ID}`

export const WIDGET_MOBILE_BREAKPOINT = 600

export const WIDGET_CLICKED_SESSION_KEY = 'multiChannelClicked'

export const WIDGET_EVENT = {
  OPEN_WIDGET: 'pp-open-widget'
}

export const HELP_DIALOG = {
  title: 'Need help?',
  description: 'Connect with us!'
}

export const MULTICHANNEL_LOCATIONS_HEADING_TEXT = {
  HEADING: 'Hello! 👋 ',
  SUB_HEADING: 'Please contact us at the following locations.'
}
